import { z } from "zod";

export const homeSearchSchema = z.object({
  projectId: z.string().optional(),
});

export const resultsSearchSchema = z.object({
  sessionId: z.string(),
  requestId: z.string(),
  prompt: z.string().optional(),
  projectId: z.string().optional(),
});

export const refineSearchSchema = z.object({
  imageId: z.string(),
  sessionId: z.string().optional(),
  requestId: z.string().optional(),
});

export const assetScopeSchema = z.enum(["personal", "organization"]);

export const gallerySearchSchema = z.object({
  projectId: z.string().optional(),
  sessionId: z.string().optional(),
  view: z.literal("assets").optional(),
  scope: assetScopeSchema.optional(),
});

export const sourceSearchSchema = z.object({
  // The selected catalog manufacturers. URL state so a filtered view survives
  // reload and can be shared, like the gallery's folder and view.
  manufacturer: z.array(z.string()).optional(),
  // The selected categories, by id.
  category: z.array(z.string()).optional(),
  // The selected subcategories, by id. Each narrows only its own category; a
  // selected category with none checked shows whole.
  subcategory: z.array(z.string()).optional(),
  // The catalog search, as submitted from the search box.
  q: z.string().optional(),
});
